import { render, staticRenderFns } from "./IpoList.vue?vue&type=template&id=6e71ff23&scoped=true"
import script from "./IpoList.vue?vue&type=script&lang=js"
export * from "./IpoList.vue?vue&type=script&lang=js"
import style0 from "./IpoList.vue?vue&type=style&index=0&id=6e71ff23&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e71ff23",
  null
  
)

export default component.exports